/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Housenumber1Inputs */

const en__field_housenumber1 = /** @type {(inputs: _Field_Housenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

const de__field_housenumber1 = /** @type {(inputs: _Field_Housenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hausnummer`)
};

/**
* | output |
* | --- |
* | "Number" |
*
* @param {_Field_Housenumber1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_housenumber1 = /** @type {((inputs?: _Field_Housenumber1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Housenumber1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_housenumber1(inputs)
	return de__field_housenumber1(inputs)
});
export { _field_housenumber1 as "_field_houseNumber" }